import React from 'react'
import { Button, Modal } from 'react-bootstrap'

const SaveOrDiscardModal = ({
  visible,
  onSave,
  onDiscard,
  onClose
}) => (
  <Modal show={visible} onHide={onClose}>
    <Modal.Body>
      <h4>Do you want to save your changes?</h4>
    </Modal.Body>
    <Modal.Footer>
      <Button id='discard-changes-button' bsStyle='default' onClick={onDiscard}>Discard</Button>
      <Button id='save-changes-button' bsStyle='primary' onClick={onSave}>Save</Button>
    </Modal.Footer>
  </Modal>
)

export default SaveOrDiscardModal
